"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineReminders = void 0;
const factories_1 = require("../../factories");
const getOrderLineReminders = (order_line_id, supabase) => {
    factories_1.OrderRequestFactory.getOrderLineReminders(supabase, order_line_id).then((res) => {
        if (res === undefined) {
            return res;
        }
        else {
            return res;
        }
    });
};
exports.getOrderLineReminders = getOrderLineReminders;
